export default __webpack_public_path__ + "static/media/bash.88041106.svg";